import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";

export function useRoleOptions() {
	/** Query */
	const query = useQuery({
		queryFn: async () => {
			const response = await client.roles.options.$get();
			const data = await responseHandler(response);
			return data.roles;
		},
		// "roles" is deliberately an element of the key: every role write invalidates by that
		// string, and a picker keyed apart from it would offer a role that was just renamed or
		// deleted for the cache's lifetime.
		queryKey: ["roles", "options"],
	});

	/** Return */
	return { ...query, roleOptions: guardArray(query.data) };
}
